import { render, staticRenderFns } from "./AdminListadoManual.vue?vue&type=template&id=a6a06ce8&scoped=true"
import script from "./AdminListadoManual.vue?vue&type=script&lang=js"
export * from "./AdminListadoManual.vue?vue&type=script&lang=js"
import style0 from "./AdminListadoManual.vue?vue&type=style&index=0&id=a6a06ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a06ce8",
  null
  
)

export default component.exports